<template>
  <fb-main-body>

    <el-form label-width="auto">
      <el-form-item class="form-item" :label="$t('lang.轮播图名称')" required>
        <el-input v-model="formData.name" :placeholder="$t('lang.轮播图名称')" disabled />
      </el-form-item>

      <el-form-item class="form-item" :label="$t('lang.标识')" required>
        <el-select v-model="formData.flag" disabled>
          <el-option :label="$t('lang.APP首页')" value="APP_HOME" />
          <el-option :label="$t('lang.设备菜谱首页')" value="RECIPE_HOME" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('lang.主语言') + '：'" required>
        <el-radio-group v-model="formData.lang" style="min-width: 800px"  disabled>
          <el-row :gutter="24">
            <el-col :span="6" v-for="lang in langList" :key="lang.value + '_key'">
              <el-radio :label="lang.value">{{ lang.name }}（{{ lang.value }}）</el-radio>
            </el-col>
          </el-row>
        </el-radio-group>
      </el-form-item>

      <el-form-item :label="$t('lang.轮播图')" required>
        <banner-table ref="bannerTable" state="check" />
      </el-form-item>

    </el-form>

  </fb-main-body>
</template>

<script>
import BannerTable from "../../components/banner/BannerTable";
import {handleFilterLang} from "../../utlis/utlis";
export default {
  name: "BannerDetail",
  components: {BannerTable},
  data() {
    return {
      api: {
        detail: this.$api.banner.detail,
      },
      formData: {
        name: "",
        brandOwnerCode: "",
        flag: "",
        code: "",
        lang: "",
      },
    }
  },
  methods: {
    // 加载详情
    handleLoadDetail() {
      this.$http.post(this.api.detail, this.$qs.stringify(this.$route.query)).then(res => {
        if(res.data.status != 200) {
          this.$message.error(res.data.desc);
          return;
        }
        let data = res.data.data.ccBanner;
        for (const key in this.formData) {
          this.formData[key] = data[key];
        }
        this.$nextTick(() => {
          this.$refs.bannerTable.setData(data.items);
        })
      })
    },
  },
  computed: {
    langList() {
      let list = handleFilterLang(this);
      return list || [];
    }
  },
  created() {
    this.handleLoadDetail();
  },
}
</script>

<style scoped>
.form-item {
  width: 500px;
}

.el-select {
  width: 100%;
}
/deep/ .el-radio {
  line-height: 40px;
}

</style>